import React, { useEffect, useState, useRef } from 'react';
import { ParentLayout } from '../../../layout/parentLayout';
import NewSideBarParent from '../../../components/NewSideBarParent';
import Feed from '../../../components/Feed';
import RightBottomLinks from '../../../components/RightBottomLinks';
import { useGetContentQuery } from '../../../service/content';
import { CONTENT_TYPE } from '../../../constants/enums';
import ReelsParent from '../../../components/ReelVideoParent';
import ArrowCircleUpIcon from '@mui/icons-material/ArrowCircleUp';
import ArrowCircleDownIcon from '@mui/icons-material/ArrowCircleDown';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import Loader from '../../../constants/Loader';

function Videos() {
    const sliderRef = useRef<any>(null);
    const [page, setPage] = useState(1);
    const [reel, setReel] = useState<any[]>([]);
    const [hasMore, setHasMore] = useState(true);

    // get content when page changes
    const { data: reelsData, isFetching } = useGetContentQuery({
        page,
        contentType: CONTENT_TYPE.SHORT_VIDEO,
        limit: 5,
        setting: 1,
    });

    // merge new data when fetched
    useEffect(() => {
        if (reelsData?.statusCode === 200) {
            const newData = reelsData?.data?.data || [];
            if (page === 1) {
                setReel(newData);
            } else {
                setReel(prev => [...prev, ...newData]);
            }
            // if returned less than limit → no more data
            if (newData.length < 5) {
                setHasMore(false);
            }
        }
    }, [reelsData, page]);

    const settings = {
        vertical: true,
        verticalSwiping: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: false,
        dots: false,
        arrows: false,
        beforeChange: (_: number, next: number) => {
            if (next >= reel.length - 1 && hasMore && !isFetching) {
                setPage(prev => prev + 1);
            }
        }
    };

    return (
        <ParentLayout className="role-layout">

            <main className="content">
                <section className="uh_spc home_wrp">
                    <div className="conta_iner v2">
                        <div className="mn_fdx">
                            <NewSideBarParent />
                            <div className="mdl_cntnt video_content">
                                {/* Slider */}
                                <Slider {...settings} ref={sliderRef}>
                                    {reel?.map((item: any) => (
                                        <div key={item.id}>
                                            <ReelsParent data={item} />
                                        </div>
                                    ))}
                                </Slider>

                                {/* Custom arrows */}
                                <div className='video_arrows'>
                                    <ArrowCircleUpIcon
                                        onClick={() => sliderRef.current?.slickPrev()}
                                        style={{ fontSize: 32, cursor: 'pointer', margin: '5px' }}
                                    />
                                    <ArrowCircleDownIcon
                                        onClick={() => sliderRef.current?.slickNext()}
                                        style={{ fontSize: 32, cursor: 'pointer', margin: '5px' }}
                                    />
                                </div>
                            </div>

                            <div className="sidebar_rt">
                                <Feed />
                                <RightBottomLinks />
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </ParentLayout>
    );
}

export default Videos;
